import styled from "styled-components";

export const StyledForm = styled.form`
& .MuiFormControl-root{
    width: 80%;
    margin: 8px;
}
`;